module.exports = __webpack_public_path__ + "img/ap32-landing2-register-btn.9f4075f6.png";